import { api } from './api';

export interface EmailReceiptTimelineEntry {
  event: string;
  label: string;
  occurred_at: string;
}

export interface EmailReceipt {
  id: string;
  email_type: string;
  to_email: string;
  subject: string | null;
  sent_at: string;
  status: string;
  error_detail: string | null;
  resend_message_id: string | null;
  site_id: string | null;
  site_name: string | null;
  inspection_id: string | null;
  sent_by: string | null;
  sent_by_name: string | null;
  attachment_count: number;
  attachment_names: string[] | null;
  /** What actually happened to it: delivered / bounced / delayed / accepted. */
  delivery_status: string;
  delivered_at: string | null;
}

export interface EmailReceiptDetail extends EmailReceipt {
  timeline: EmailReceiptTimelineEntry[];
}

export interface EmailReceiptPage {
  total: number;
  items: EmailReceipt[];
}

export interface EmailReceiptFilters {
  to_email?: string;
  site_id?: string;
  inspection_id?: string;
  email_type?: string;
  /** 'problem' narrows to bounced / spam-flagged / failed sends. */
  delivery?: string;
  sent_after?: string;
  sent_before?: string;
  skip?: number;
  limit?: number;
}

export const emailReceiptsService = {
  async list(filters: EmailReceiptFilters = {}): Promise<EmailReceiptPage> {
    const params = Object.fromEntries(
      Object.entries(filters).filter(([, v]) => v !== undefined && v !== '')
    );
    const { data } = await api.get<EmailReceiptPage>('/email-receipts', {
      params,
    });
    return data;
  },

  async mine(skip = 0, limit = 50): Promise<EmailReceiptPage> {
    const { data } = await api.get<EmailReceiptPage>('/email-receipts/mine', {
      params: { skip, limit },
    });
    return data;
  },

  async get(id: string): Promise<EmailReceiptDetail> {
    const { data } = await api.get<EmailReceiptDetail>(`/email-receipts/${id}`);
    return data;
  },
};
